import { Helmet } from 'react-helmet-async';
import RentalOrdersView from '../../../components/dashboard/rentals/RentalOrdersView';

export default function CompletedRentals() {
  return (
    <>
      <Helmet>
        <title>Previous Rentals | Platform Solutions</title>
      </Helmet>

      <RentalOrdersView orderStatus="previous" />
    </>
  );
}
